import { render } from "./EthereumRateChart.vue?vue&type=template&id=cbbce31a&ts=true"
import script from "./EthereumRateChart.vue?vue&type=script&lang=ts"
export * from "./EthereumRateChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__